import { atom } from "recoil";

const topicLoading = atom({
  key: 'topic-loading',
  default: false,
});

const topicData = atom({
  key: 'topic-data',
  default: [],
});

export {
  topicLoading,
  topicData,
};